import { Button, CircularProgress, Grid, Typography } from '@material-ui/core';
import { ShareFixedHeader } from '@orientaction/components';
import { useLanguage } from '@orientaction/hooks';
import { useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { apiServiceNative } from '../../../utils/fetchNative';
import style from '../../AdminGame/style';

const ViewEbookDisconnected = () => {
  useLanguage();
  const classes = style();
  const [url, setUrl] = useState('');
  const [title, setTitle] = useState('');
  const [status, setStatus] = useState('');
  const [loading, setLoading] = useState<boolean>(true);
  const history = useHistory();
  const { id }: { id: string } = useParams();

  useEffect(() => {
    const fetchEbookDetails = async () => {
      setLoading(true);
      setStatus('');
      try {
        const response = await apiServiceNative.get(`/api/ebook-details/${id}`);
        if (response) {
          setTitle(response.title || '');
          setUrl(response.img?.url || response.couverture || '');
          setStatus(response.status || '');
        }
      } catch (error) {
        console.error('Error fetching ebook details:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchEbookDetails();
  }, [id]);

  const isDraft = status !== 'published';

  const startEbook = async () => {
    if (isDraft) {
      return;
    }
    setLoading(true);
    try {
      const response = await apiServiceNative.post('/api/create-ebook-result', {
        serious_ebook_id: id,
        acquisition_source: 'share_link',
      });
      const resultId = response?.id;
      if (resultId) {
        history.push(`/ebook/view/${resultId}/0`);
      }
    } catch (error) {
      console.error('Erreur lors de la création du résultat ebook :', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <ShareFixedHeader />
      <div className={classes.grayBGContent}>
        <div className={classes.containerDiv}>
          {loading ? (
            <div style={{ height: '100vh' }}>
              <CircularProgress
                size={40}
                style={{
                  position: 'absolute',
                  left: '50%',
                  top: '50%',
                  zIndex: 3,
                  color: 'white',
                }}
              />
            </div>
          ) : (
            <Grid container={true} direction="row" justifyContent="center" alignItems="center">
              {isDraft ? (
                <Grid item={true} sm={12} xs={12}>
                  <Typography variant="h4" className={classes.title} style={{ color: 'white' }}>
                    Cet e-book n&apos;est pas disponible
                  </Typography>
                </Grid>
              ) : (
                <>
                  <Grid
                    item={true}
                    sm={12}
                    xs={12}
                    style={{ display: 'flex' }}
                    className={classes.btnContainer}
                    justifyContent="center"
                    alignItems="center">
                    <Button
                      className={classes.btnFull}
                      style={{ background: 'white' }}
                      onClick={startEbook}>
                      Commencer
                    </Button>
                  </Grid>
                  <Grid item={true} sm={4} xs={12}>
                    <div className={classes.containerCover}>
                      <div className={classes.content}>
                        <Typography variant="h4" className={classes.title}>
                          {title}
                        </Typography>
                        <div className={classes.containerElement}>
                          <img className={classes.img} src={url} alt="couverture ebook" />
                        </div>
                      </div>
                    </div>
                  </Grid>
                </>
              )}
            </Grid>
          )}
        </div>
      </div>
    </>
  );
};

export default ViewEbookDisconnected;
